import React from 'react';
import { PAGE_CONFIG } from './pageConfig';
import { PAGE_CONFIG_API } from '@home/_config/constant';
import CommonPageRender from '@home/components/CommonPageRender';
import { useParams } from 'umi';
import './index.scss';

const CBT = () => {
  const { studioId, gameCode } = useParams() || {} as any;
  
  return (
    <CommonPageRender
      className="dbh-studio-cbt-page"
      reqParams={'/cbt'}
      key={studioId+gameCode}
      frameType='game'
      // @ts-ignore
      pageConfigInit={PAGE_CONFIG}
      api={PAGE_CONFIG_API}
    />
  );
};

export default CBT;
